import React from 'react';
import { useDispatch } from 'react-redux';
import { selectItem } from '../../store/slices/timelineSlice';
import { setMenuVisible } from '../../store/slices/editorUISlice';
import sectionMenuClasses from '../../../../components/CreateMeetingFooter/SectionMenu/styles.module.scss';
import footerClasses from '../../../../components/CreateMeetingFooter/styles.module.scss';

export default function TimelineGap({
  item,
  isPreviewMode,
  isTemplateMode = false,
  isGapHovered,
  gapHoverTimerRef,
  plusSignRef,
  setHoveredGapAfterItemId,
}) {
  const dispatch = useDispatch();

  return (
    <li
      style={{
        display: 'inline-block',
        width: 50,
        height: 120,
        position: 'relative',
        marginRight: 0,
        background: 'transparent',
        borderRadius: 8,
        transition: 'none',
        zIndex: 8,
        cursor: isPreviewMode ? 'default' : 'pointer',
      }}
      onMouseEnter={() => {
        if (isPreviewMode) return;
        // eslint-disable-next-line no-param-reassign
        if (gapHoverTimerRef.current) clearTimeout(gapHoverTimerRef.current);
        // eslint-disable-next-line no-param-reassign
        gapHoverTimerRef.current = setTimeout(() => {
          setHoveredGapAfterItemId(item.id);
        }, 200);
      }}
      onMouseLeave={() => {
        // eslint-disable-next-line no-param-reassign
        if (gapHoverTimerRef.current) clearTimeout(gapHoverTimerRef.current);
        setHoveredGapAfterItemId(null);
      }}
    >
      {/* Move THE Add Section button into the gap when hovered */}
      {!isPreviewMode && !isTemplateMode && isGapHovered && (
        <div
          className={footerClasses.sectionMenuContainer}
          style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', padding: '16px 6px' }}
        >
          <div
            className={sectionMenuClasses.SectionMenu}
            onClick={(e) => {
              e.stopPropagation();
              // Set ref to this element before opening menu
              const svgElement = e.currentTarget.querySelector('svg');
              if (svgElement) {
                // eslint-disable-next-line no-param-reassign
                plusSignRef.current = svgElement;
              }
              // Insert after this item
              dispatch(selectItem(item.id));
              // Open the add menu (menu position will anchor to plusSignRef)
              dispatch(setMenuVisible(true));
            }}
          >
            <div className={sectionMenuClasses.toggle}>
              <svg
                width="34"
                height="33"
                viewBox="0 0 34 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.8361 0V12.1291H0.707031V20.2151H12.8361V32.3442H20.9222V20.2151H33.0513V12.1291H20.9222V0H12.8361Z"
                  fill="#F8585C"
                />
              </svg>
            </div>
          </div>
        </div>
      )}
    </li>
  );
}
